// import React from 'react';
// import { Link } from 'react-router-dom';
// import logo from '../Images/logo.png'; // Replace with your logo path

// const Header = () => {
//   return (
//     <div style={styles.header}>
//       <img src={logo} alt="Logo" style={styles.logo} />
//       {/* <nav style={styles.nav}>
//         <Link to="/" style={styles.link}>Home</Link>
//         <Link to="/about" style={styles.link}>About</Link>
//         <Link to="/businessmodule" style={styles.link}>Business Module</Link>
//         <Link to="/services" style={styles.link}>Services</Link>
//         <Link to="/projects" style={styles.link}>Projects</Link>
//         <Link to="/contact" style={styles.link}>Contact</Link>
//       </nav> */}
//     </div>
//   );
// };

// const styles = {
//   // header: {
//   //   // display: 'flex',
//   //   // alignItems: 'center',
//   //   // background: 'white',
//   //   // padding: '10px 20px',
//   //   // color: 'orange',
//   //   // justifyContent: 'space-between',
//   //   // flexWrap: 'wrap',
//   //   // borderBottom: '4px solid orange',
//   //   // position: 'fixed',
//   //   width: '95%',
//   //   backgroundColor: 'white',
//   //   color: '#fff',
//   //   display: 'flex',
//   //   justifyContent: 'space-between',
//   //   alignItems: 'center',
//   //   padding: '0 2rem',
//   //   zIndex: 1000, // keep it on top
//   //   // borderBottom: '4px solid orange',
//   //   boxShadow: '0 2px 5px rgba(0,0,0,0.1)',


//   // },
//   header: {
//     width: '95%',
//     padding: '1rem 2rem',
//     margin: 'auto',
//     borderRadius: '20px',
//     background: 'rgba(255, 255, 255, 0.1)',
//     // background:"red",
//     boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.2)',
//     backdropFilter: 'blur(40px)',
//     WebkitBackdropFilter: 'blur(12px)',
//     border: '1px solid rgba(255, 255, 255, 0.3)',
//     color: '#0A1733',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     zIndex: 1000,
//   },

//   logo: {
//     height: 60,
//     filter: 'drop-shadow(2px 2px 3px #000)', // makes logo float a bit
//     transform: 'translateZ(20px)',
//   },
//   nav: {
//     display: 'flex',
//     gap: '20px',
//     flexWrap: 'wrap'
//   },
//   link: {
//     color: '#091E3E',
//     textDecoration: 'none',
//     fontWeight: 'bold'
//   }
// };

// export default Header;



// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import logo from '../Images/Logo_04-removebg-preview (1).png';
// import './Header.css'; // 👈 Import CSS file

// const Header = () => {
//   return (
//     <div style={styles.wrapper}>
//       <img src={logo} alt="Logo" style={styles.logo} />
//       <nav style={styles.nav}>
//         {navItems.map((item) => (
//           <NavLink
//             key={item.path}
//             to={item.path}
//             className={({ isActive }) =>
//               isActive ? 'nav-link active-link' : 'nav-link'
//             }
//           >
//             {item.label}
//           </NavLink>
//         ))}
//       </nav>
//     </div>
//   );
// };

// const navItems = [
//   { label: 'Home', path: '/' },
//   { label: 'About', path: '/about' },
//   { label: 'Business Module', path: '/BusinessModule' },
//   { label: 'Services', path: '/Services' },
//   { label: 'Projects', path: '/Projects' },
//   { label: 'Our Team', path: '/OurTeam' },
//   { label: 'Contact', path: '/contact' },
// ];

// const styles = {
//   // wrapper: {
//   //   width: '100%',
//   //   height: '10%',
//   //   padding: '1rem 2rem',
//   //   position: 'fixed',
//   //   top: 0,
//   //   left: 0,
//   //   display: 'flex',
//   //   justifyContent: 'space-between',
//   //   alignItems: 'center',
//   //   zIndex: 999,
//   //   backgroundColor: 'rgba(255, 255, 255, 0.7)',
//   //   backdropFilter: 'blur(5px)',
//   //   WebkitBackdropFilter: 'blur(5px)',
//   //   boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
//   //   borderBottom: '1px solid rgba(255,255,255,0.3)',
//   // },
//   wrapper: {
//     width: '100%',
//     height: '15%',
//     padding: '1rem 2rem',
//     boxSizing: 'border-box', // ✅ Add this line
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     zIndex: 999,
//     backgroundColor: 'rgba(255, 255, 255, 0.7)',
//     backdropFilter: 'blur(5px)',
//     WebkitBackdropFilter: 'blur(5px)',
//     boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
//     borderBottom: '1px solid rgba(255,255,255,0.3)',
//     // overflowX: 'hidden', // ✅ Prevent horizontal overflow
//   },

//   logo: {
//     height: '60px',
//     // filter: 'drop-shadow(2px 2px 3px #000)',
//     // transform: 'translateZ(20px)',
//   },
//   nav: {
//     display: 'flex',
//     gap: '1rem', // or even smaller like '0.8rem'
//     flexWrap: 'wrap', // Optional: allow nav items to wrap on smaller screens
//   },
// };

// export default Header;


import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../Images/Logo_04-removebg-preview (1).png";
import "./Header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  return (
    <header className="header">
      {/* Logo */}
      <img src={logo} alt="Logo" className="logo" />

      {/* Navigation */}
      <nav className={`nav ${isOpen ? "open" : ""}`}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              isActive ? "nav-link active-link" : "nav-link"
            }
            onClick={closeMenu}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Hamburger Icon */}
      <div className="menu-icon" onClick={toggleMenu}>
        {isOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
      </div>
    </header>
  );
};

const navItems = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Business Module", path: "/BusinessModule" },
  { label: "Our Services", path: "/OurServices" },
  { label: "Projects", path: "/Projects" },
  // { label: "Our Team", path: "/OurTeam" },
  // { label: "Our Footprint", path: "/USAMap" },

  { label: "Contact", path: "/contact" },
];

export default Header;
